export default __webpack_public_path__ + "static/media/an4.261b78d0.jpg";